/**
 * Safe localStorage access.
 *
 * Wraps get/set/remove in a `window` guard + try/catch so private-mode, quota,
 * and no-window (SSR/test) environments degrade to no-ops or `null` instead of
 * throwing. Call sites previously hand-rolled this guard inconsistently — some
 * threw in private mode. These are drop-in replacements for
 * `window.localStorage.{getItem,setItem,removeItem}`.
 */
export function getStored(key: string): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setStored(key: string, value: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Private mode / quota exceeded — persisting is best-effort.
  }
}

export function removeStored(key: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // Private mode — nothing to remove.
  }
}
